import { FabricObject, Textbox } from 'fabric';

export interface WrapTextConfig {
  pieceId: string;
  paddingX?: number;
  minWidth?: number;
}

/** Resizes `target.width` to match `source`'s rendered text width plus padding. */
export function wrapToText(target: FabricObject, source: Textbox, cfg: WrapTextConfig): void {
  const padX = cfg.paddingX ?? 0;
  const textWidth = source.calcTextWidth?.() ?? 0;
  const width = Math.max(textWidth + 2 * padX, cfg.minWidth ?? 0);
  target.set({ width });
}
